import React, { useEffect, useState } from 'react';
import { ArrowLeft, Save, Plus, } from 'lucide-react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import { getPurchaseDetails, addPurchaseDetails, updatePurchaseDetails, getAddressAPI } from '@/redux/Purchase/actions';
import { SearchBar } from '../SearchBox/SearchBar';
import FileUpload from '../FileUpload/FileUpload';
import { validateForm } from "../ui/useFormValidation";
import CelebrationButton from '../ui/CelebrationButton/CelebrationButton';
import { showToast } from '@/redux/Toast/actions';
import { callLoader } from '@/redux/Loader/actions';
import { getItemColumns } from './columns';
import { DataTable } from '../ui/table';
import DatePicker from 'react-datepicker';

const PurchaseOrderFormSleek = ({ onBack, orderDataId = null }) => {

    const dispatch = useDispatch();
    const { countryList, incoTermsList, quantityTypeList, uomTypeList } = useSelector((state) => state.common);
    const [formData, setFormData] = useState();
    const [items, setItems] = useState([]);
    const [errors, setErrors] = useState({});
    const [authUser] = JSON.parse(localStorage.getItem('authUser') ?? "[{}]");
    const userName = authUser?.username;
    const companyId=authUser?.companyId;
        const { isAnimate } = useSelector((state) => state.toast);
    
    useEffect(() => {
        if (orderDataId != 0 && orderDataId != null) {
            _getPurchaseOrder();
        } else {
            _setNewPurchaseOrder();
        }
    }, [orderDataId])

    const _getPurchaseOrder = async () => {
         try {
                dispatch(callLoader(1));
             const resultData = await dispatch(getPurchaseDetails(orderDataId));
        console.log(resultData);
        setFormData(resultData);
        setItems(resultData?.lineItems ?? []);
            dispatch(callLoader(0));
            console.log(moment(resultData?.poDate).format('YYYY-MM-DD'));
         } catch (error) {
                dispatch(callLoader(0));
         }

    
    }
    const _setNewPurchaseOrder = async () => {
        setFormData(null);
        setItems([{
            purchaseOrderLineItemId: 0,
            sku: '',
            skuItemDesc: '',
            uot: 0,
            casesPerUot: 0,
            remainingUnit: 0,
            remainingCases: 0,
            caseCount: 0,
            caseCountUOM: 'SELECT UOMCD',
            packing: '0.00',
            quantity: '0.00',
            metricId: 1,
            metricType: 'TON',
            price: 0,
            total: 0,
            warehouse: '',
            notes: ''
        }])
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleItemChange = (index, field, value) => {
        const updated = [...items];
        updated[index][field] = value;
        if (field === 'quantity' || field === 'price') {
            const qty = parseFloat(updated[index].quantity) || 0;
            const price = parseFloat(updated[index].price) || 0;
            updated[index].total = (qty * price).toFixed(2);
        }
        console.log(updated);
        setItems(updated);
    };

    const addItem = () => {
        setItems([...items,
        {
            purchaseOrderLineItemId: 0,
            sku: '',
            skuItemDesc: '',
            uot: 0,
            casesPerUot: 0,
            remainingUnit: 0,
            remainingCases: 0,
            caseCount: 0,
            caseCountUOM: 'SELECT UOMCD',
            packing: '0.00',
            quantity: '0.00',
            metricId: 0,
            metricType: '',
            price: 0,
            total: 0,
            warehouse: '',
            notes: ''
        }
        ]);
    };

    const removeItem = (index) => {
        if (items.length > 1) {
            setItems(items.filter((_, i) => i !== index));
        }
    };

    const subtotal = items.reduce((sum, item) => sum + parseFloat(item.total || 0), 0);

    const formhandleSubmit = async (e) => {
        e.preventDefault();
    }

    const _setAddress = async (type, id) => {
        const address = await getAddressAPI(id);
        setFormData(prev => ({ ...prev, [`${type}`]: address }));
    };

    const validationConfig = {

        poNumber: { required: true, label: "Purchase Order" },
        vendor: { required: true, label: "vendor" },
      
        destination: { required: true, label: "Destination" },
       
    };



    const handleSubmit = async (e) => {
        var itmPayload = [];
        items.map((v, i) => {
            const ob = {
                "PURCHASEORDER_LINEITEM_ID": v?.purchaseOrderLineItemId ?? 0,
                "SKU": v?.sku,
                "SKU_ITEM_DESC": v?.skuItemDesc,
                "UOT": v?.uot,
                "CASES_PER_UOT": v?.casesPerUot,
                "UOM_TYPE_ID": v?.uomTypeId,
                "UOM_TYPE": v?.uomType,
                "PACKING": v?.packing,
                "QUANTITY": v?.quantity,
                "METRIC_ID": v?.metricId,
                "METRIC_TYPE": v?.metricType,
                "PRICE": v?.price,
                "WAREHOUSE": v?.warehouse,
                "NOTES": v?.notes,
                "IS_ACTIVE": v?.isActive != false ? true : false
            }
            v?.sku ? itmPayload.push(ob) : null;
        });
        const payload = {
            "PURCHASEORDER_ID": orderDataId ?? 0,
            "COMPANY_ID": companyId,
            "PO_DATE": formData?.poDate,
            "ASSIGN_TO_ID": 101,
            "ASSIGN_TO_NAME": "John Smith",
            "VENDOR_ID": formData?.vendorId,
            "VENDOR": formData?.vendor,
            "VENDOR_ADDRESS": formData?.vendorAddress,
            "SUPPLIER_ID": formData?.supplierId,
            "SUPPLIER": formData?.supplier,
            "SUPPLIER_ADDRESS": formData?.supplierAddress,
            "CONSIGNEE_ID": formData?.consigneeId,
            "CONSIGNEE": formData?.consignee,
            "CONSIGNEE_ADDRESS": formData?.consigneeAddress,
            "WAREHOUSE_ID": formData?.warehouseId,
            "WAREHOUSE": formData?.warehouse,
            "WAREHOUSE_ADDRESS": formData?.warehouseAddress,
            "INCOTERM_ID": formData?.incotermId,
            "INCOTERM": formData?.incoterm,
            "DESTINATION": formData?.destination,
            "DESTINATION_COUNTRY": formData?.destinationCountry,
            "DELIVERED_BY": formData?.deliveredBy,
            "DELIVERED_BY_DATE": formData?.deliveredByDate,
            "PURCHASER": formData?.purchaser,
            "REMARKS": formData?.remarks,
            "IS_ACTIVE": formData?.isActive != false ? true : false,
            "CREATED_BY": userName,
            "LineItems": itmPayload
        }

        
        const validationErrors = validateForm({
            data: formData,
            items,
            rules: validationConfig,
        });

        setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return;
        }
        
    dispatch(callLoader(1));
       try {
         if (orderDataId != 0 && orderDataId != null) {
            const updateDetails = await updatePurchaseDetails(payload);
                dispatch(showToast("Record saved successfully", "success", true))
            console.log(updateDetails);
        } else {
            const addDetails = await addPurchaseDetails(payload);
            console.log(addDetails);
              dispatch(showToast("Record saved successfully", "success", true))
        }
    dispatch(callLoader(0));
       } catch (error) {
            dispatch(callLoader(0));
       }
    

    };

    const handleDateChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value // YYYY-MM-DD
    }));
  };

  const columns = getItemColumns({
  handleItemChange,
  uomTypeList,
  quantityTypeList,
});

const options = (countryList || [])?.map((loc) => {
    const match = (loc?.incoterm || "").match(/\(([^)]+)\)/);
    const code = match ? match[1] : null;
    return {
      value: code,
      label: loc?.incoterm,
    };
  });
    return (
      <div className="h-full bg-slate-50 dark:bg-slate-950">
        <div className="mx-auto p-4">
          {/* Compact Header */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <button
                onClick={onBack}
                className="p-2 hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg transition-colors"
              >
                <ArrowLeft className="w-5 h-5 text-slate-600 dark:text-slate-400" />
              </button>
              <div>
                <h1 className="text-xl font-bold text-slate-900 dark:text-white">
                  {orderDataId ? "Edit Purchase Order" : "New Purchase Order"}
                </h1>
                <p className="text-xs text-slate-500 dark:text-slate-400">
                  {orderDataId
                    ? `Editing ${orderDataId}`
                    : "Create a new order"}
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <button
                type="button"
                onClick={onBack}
                className="px-4 py-2 text-sm text-slate-600 dark:text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-800 rounded-lg transition-all"
              >
                Cancel
              </button>
              <CelebrationButton
                onClick={() => handleSubmit()}
                label={"Save Order"}
                className="px-4 py-2 text-sm bg-[#0072FF] hover:bg-[#0062DD] text-white rounded-lg font-medium transition-all flex items-center space-x-1"
                icon={<Save className="w-4 h-4" />}
                isSuccess={isAnimate}
              />
            </div>
          </div>

          <form id="po-form" onSubmit={formhandleSubmit} className="space-y-4">
            {/* Order Details Section */}
            <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 p-4">
              <h2 className="text-sm font-semibold text-slate-900 dark:text-white mb-3">
                Order Details
              </h2>
              <div className="grid grid-cols-4 gap-3">
                <div className="">
                  <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                    Purchase Order # <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="purchaseOrderId"
                    value={formData?.poNumber}
                    readOnly
                    className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                    Inco Terms
                  </label>
                  <select
                    name="incotermId"
                    value={formData?.incotermId}
                    onChange={(d) => {
                      handleInputChange({
                        target: { name: "incotermId", value: d.target.value },
                      });
                      handleInputChange({
                        target: {
                          name: "incoterm",
                          value: d.target.options[d.target.selectedIndex].text,
                        },
                      });
                    }}
                    className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                  >
                    <option value="">SELECT TERMS</option>
                    {incoTermsList?.map((term, key) => (
                      <option key={key} value={term?.id}>
                        {term?.incoterm}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <div>
                                <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                                    Assign To
                                </label>
                                <select
                                    name="assignToId"
                                    value={formData?.assignToId}
                                    onChange={handleInputChange}
                                    className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                                >
                                    <option value="">SELECT SALES PERSON</option>
                                    <option value={formData?.assignToId}>{formData?.assignToName}</option>
                                    <option>Jane Smith</option>
                                </select>
                            </div> */}
                <div>
                  <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                    Purchaser
                  </label>
                  <input
                    type="text"
                    name="purchaser"
                    value={formData?.purchaser}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                    Purchase Order Date
                  </label> 
                    <DatePicker
                      selected={
                        formData?.poDate
                          ? new Date(formData.poDate)
                          : null
                      }
                      showIcon
                      onChange={(date) =>
                        handleDateChange(
                          "poDate",
                          moment(date).format("YYYY-MM-DD"),
                        )
                      }
                      dateFormat="dd MMM yyyy"
                      placeholderText="Select Date"
                      className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                    />
                  {/* <input
                                    type="date"
                                    name="poDate"
                                    value={formData?.poDate ? moment(formData?.poDate).format('YYYY-MM-DD') : ''}
                                    onChange={handleInputChange}
                                    className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                                /> */}
                </div>
              </div>
            </div>

            {/* Trade Partner Section */}
            <div className="grid grid-cols-3 gap-4">
              <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 p-4 col-span-2">
                <h2 className="text-sm font-semibold text-slate-900 dark:text-white mb-3">
                  Trade Partner
                </h2>
                <div className="grid grid-cols-2 gap-6">
                  {/* Left Column - Vendor */}
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Vendor <span className="text-red-500">*</span>
                    </label>
                    <SearchBar
                      searchAPI={
                        "v1/AutoSuggestion/GetVendorSuggestion?Prefix="
                      }
                      selectReacord={(d) => {
                        handleInputChange({
                          target: { name: "vendor", value: d?.[1] },
                        });
                        handleInputChange({
                          target: { name: "vendorId", value: d?.[0] },
                        });
                        _setAddress("vendorAddress", d?.[0]);
                      }}
                      value={formData?.vendor}
                    />
                    <textarea
                      name="vendorAddress"
                      value={formData?.vendorAddress}
                      onChange={handleInputChange}
                      rows="6"
                      className="w-full mt-2 px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF] resize-none"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Supplier
                    </label>
                    <SearchBar
                      searchAPI={
                        "v1/AutoSuggestion/GetSupplierSuggestion?Prefix="
                      }
                      selectReacord={(d) => {
                        handleInputChange({
                          target: { name: "supplier", value: d?.[1] },
                        });
                        handleInputChange({
                          target: { name: "supplierId", value: d?.[0] },
                        });
                        _setAddress("supplierAddress", d?.[0]);
                      }}
                      value={formData?.supplier}
                    />
                    <textarea
                      name="supplierAddress"
                      value={formData?.supplierAddress}
                      onChange={handleInputChange}
                      rows="6"
                      className="w-full mt-2 px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF] resize-none"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Consignee
                    </label>
                    <SearchBar
                      searchAPI={
                        "v1/AutoSuggestion/GetConsigneeSuggestion?Prefix="
                      }
                      selectReacord={(d) => {
                        handleInputChange({
                          target: { name: "consignee", value: d?.[1] },
                        });
                        handleInputChange({
                          target: { name: "consigneeId", value: d?.[0] },
                        });
                        _setAddress("consigneeAddress", d?.[0]);
                      }}
                      value={formData?.consignee}
                    />
                    <textarea
                      name="consigneeAddress"
                      value={formData?.consigneeAddress}
                      onChange={handleInputChange}
                      rows="6"
                      className="w-full mt-2 px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF] resize-none"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Warehouse
                    </label>
                    <SearchBar
                      searchAPI={
                        "v1/AutoSuggestion/GetWarehouseSuggestion?Prefix="
                      }
                      value={formData?.warehouse}
                      selectReacord={(d) => {
                        handleInputChange({
                          target: { name: "warehouse", value: d?.[1] },
                        });
                        handleInputChange({
                          target: { name: "warehouseId", value: d?.[0] },
                        });
                        _setAddress("warehouseAddress", d?.[0]);
                      }}
                    />
                    <textarea
                      name="warehouseAddress"
                      value={formData?.warehouseAddress}
                      onChange={handleInputChange}
                      rows="6"
                      className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF] resize-none mt-2"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Remarks
                    </label>
                    <textarea
                      name="remarks"
                      value={formData?.remarks}
                      onChange={handleInputChange}
                      rows="3"
                      className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF] resize-none"
                    />
                  </div>
                </div>
              </div>
              <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 p-4">
                <h2 className="text-sm font-semibold text-slate-900 dark:text-white mb-3">
                  Routing
                </h2>
                <div className="grid grid-cols-1 gap-6">
                  {/* Left Column - Vendor */}
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Delivered By
                    </label>
                    <input
                      type="text"
                      name="deliveredBy"
                      value={formData?.deliveredBy}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Delivered By Date
                    </label>

                    <DatePicker
                      selected={
                        formData?.deliveredByDate
                          ? new Date(formData.deliveredByDate)
                          : null
                      }
                      showIcon
                      onChange={(date) =>
                        handleDateChange(
                          "deliveredByDate",
                          moment(date).format("YYYY-MM-DD"),
                        )
                      }
                      dateFormat="dd MMM yyyy"
                      placeholderText="Select Date"
                      className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                    />
                    {/* <input
                                        type="date"
                                        name="deliveredByDate"
                                        value={formData?.deliveredByDate ? moment(formData?.deliveredByDate).format('YYYY-MM-DD') : ''}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                                    /> */}
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Destination <span className="text-red-500">*</span>
                    </label>
                    <SearchBar
                      searchAPI={
                        "v1/AutoSuggestion/GetDestinationSuggestion?Prefix="
                      }
                      value={formData?.destination}
                      selectReacord={(d) => {
                        handleInputChange({
                          target: { name: "destination", value: d?.[1] },
                        });
                      }}
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                      Dest. Country
                    </label>
                    <select
                      name="destinationCountry"
                      value={formData?.destinationCountry}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                    >
                      <option value="">SELECT COUNTRY OF DESTINATION</option>
                        {options &&
                      (options || []).map((item) => (
                        <option value={item?.value}>{item?.label}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* Commodity Table */}
            <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 ">
              <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 dark:border-slate-800">
                <h2 className="text-sm font-semibold text-slate-900 dark:text-white">
                  Commodity
                </h2>
                <button
                  type="button"
                  onClick={addItem}
                  className="px-3 py-1 text-xs bg-[#0072FF] hover:bg-[#0062DD] text-white rounded-lg font-medium transition-all flex items-center space-x-1"
                >
                  <Plus className="w-3 h-3" />
                  <span>Add More Row</span>
                </button>
              </div>

              <DataTable
                data={items.filter((i) => i?.isActive !== false)}
                columns={columns}
                tdClass="px-2 py-2"
                thClass="px-2 py-2 text-left text-xs font-semibold text-slate-600 dark:text-slate-400"
                trClass="hover:bg-slate-50 dark:hover:bg-slate-800/30"
                htrClass="border-b border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/50"
                boxClass="overflow-x-auto overflow-y-visible pb-[20vh] text-xs"
              />
            </div>
            {orderDataId != 0 && orderDataId != null && (
              <>
                <FileUpload
                  orderId={orderDataId}
                  orderNum={formData?.poNumber}
                  type={"purchase"}
                />
              </>
            )}
          </form>
        </div>
      </div>
    );
};

export default PurchaseOrderFormSleek;
